<template>
    <div class="ml-3 mr-3">
        <transition name="fade" mode="out-in">
            <div class="row" :style="!svgRendered && loadingSvg ? 'padding: 50px;' : ''" key="mapa-butacas" id="paso-1">
                <div class="col-12 mb-2 p-0 d-md-flex d-block justify-content-between">
                    <h3 v-if="svgRendered && !loadingSvg">Seleccione las butacas:</h3>
                </div>
                <div class="lightgray-content col-12 col-md-8 p-2" :class="{'contentor-loading-padding': loading}">
                    <ContentOrLoading>
                        <LeafletComponent
                            v-if="svgRendered && !loadingSvg"
                            :svgRendered="svgRendered"
                            :originalColor="originalColor"
                            @isPanning="(e) => isPanning = e"
                        />
                    </ContentOrLoading>
                </div>
                <div class="col-12 col-md-4 mt-3" v-if="butacasSeleccionadas && butacasSeleccionadas.length > 0">
                    <ContentOrLoading>
                        <b-card v-if="!loading">
                            <div class="col-12 text-center">
                                <h3>TUS BUTACAS</h3>
                            </div>
                            <div class="col-12 text-center">
                                <template v-for="(butaca, index) in butacasSeleccionadas">
                                    <div class="col-12 bg-secondary pb-2 mb-2" :key="index">
                                        <p v-if="!regionSeleccionada" class="mb-0 p-1">{{ ++index }}. Fila: {{ butaca.fila }} - Butaca: {{ butaca.butaca }}</p>
                                        <p v-else class="mb-0 p-1">{{ ++index }}. Butaca sin numerar</p>
                                    </div>
                                </template>
                            </div>
                            <div class="col-12 text-right">
                                <Button @click="bloquearButacas()" class="btn-block" :disabled="!paso_activo">CONTINUAR COMPRA</Button>
                            </div>
                        </b-card>
                    </ContentOrLoading>
                </div>
            </div>
        </transition>
        <ModalRegionSinNumerar
            v-if="showModalRegionSinNumerar"
            :precios="preciosSeleccionados"
            :regionSeleccionada="regionSeleccionada"
            @setAsientos="(asientos) => setAsientos(asientos)"
            @close="closeModal"
        />
    </div>
</template>

<script>
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import { Popover } from 'bootstrap';
import ModalRegionSinNumerar from './ModalRegionSinNumerar.vue';

export default {
    props: ['recinto_id', 'paso_activo'],
    data() {
        return {
            loading: false,
            loadingSvg: false,
            butacas: null,
            butacasSeleccionadas: [],
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            seleccionadaColor: '#8CA9D9',
            bloqueadaColor: '#BF95C4',
            svgRendered: null,
            isPanning: null,
            session_id: null,
            svg: '',
            regiones: null,
            preciosSeleccionados: [],
            showModalRegionSinNumerar: false,
            regionSeleccionada: null
        }
    },
    methods: {
        setAsientos(asientos) {
            asientos.forEach(asiento => {
                this.butacasSeleccionadas.push(asiento);
            });

            this.bloquearButacas();
        },
        bloquearButacas() {
            this.loading = true;

            let data;
            if (!this.regionSeleccionada) {
                data = this.butacasSeleccionadas.map(butaca => {
                    return {
                        'plazaId': butaca.id,
                    }
                });
            } else {
                data = this.butacasSeleccionadas.map(butaca => {
                    return {
                        'asiento': butaca.asiento,
                        'fila': butaca.fila,
                        'zona_id': butaca.zona_id,
                        'zona_nombre': butaca.zona_nombre
                    }
                });
            }

            const params = {
                filters: {},
                event_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
            };

            let url;
            if (this.regionSeleccionada) {
                url = 'front.bloquear.asientos';
                params.zona_id = this.regionSeleccionada.id;
                params.asientos = data;
            } else {
                url = 'back.event.sesiones.recinto.taquilla.bloquear-plazas';
                params.recinto_id = this.recinto_id;
                params.data = data;
            }


            this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                this.session_id = res.data.session_id;
                this.$emit('goTo', 3, this.butacasSeleccionadas, this.session_id, true)
                this.loading = false
            }).catch(error => {
                if (error?.response?.data?.message === 'Plazas ocupadas') {
                    this.$toast.error('Plazas ocupadas');
                    this.butacasSeleccionadas = [];
                    this.svgRendered = null;
                    this.getButacas();
                } else {
                    console.error('Error al bloquear las butacas');
                }
            });
        },
        getSvg() {
            this.loading = true;
            this.loadingSvg = true;
            const params = {
                filters: {},
                recinto_id: this.recinto_id
            }

            this.$store.dispatch(this.config.getVuexAlias('recinto.svg'), params).then(res => {
                this.svg = res.data.svg;
                this.renderLeafletSvg(this.svg);
                this.loading = false;
                this.loadingSvg = false;
            }).catch(() => {
                console.error('Error al recuperar el svg');
            });
        },
        getButacas() {
            this.loading = true;

            const params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.recinto_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.butacas'), params).then(res => {
                this.butacas = res.data.data;
                this.getSvg();
                this.loading = false;
            }).catch(() => {
                console.error('Error al recuperar las butacas');
            });
        },
        getRegionesSinNumerar() {
            this.loading = true;

            const params = {
                filters: {},
                evento_id: this.$route.params.evento_id,
                sesion_id: this.$route.params.sesion_id,
                recinto_id: this.recinto_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-sin-asientos'), params).then(res => {
                this.regiones = res.data.data;
            }).catch(() => {
                console.error('Error al recuperar las butacas');
            }).finally(() => {
                this.loading = false;
            });
        },
        renderLeafletSvg(svg) {
            const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);
            const regionesFiltered = this.regiones.filter(region => region.svg_id);

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;

            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            const regiones = svgElement.querySelectorAll('[id^="region"]');

            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);
                
                
                if (butaca) {
                    const title = this.getButacaName(butaca);

                    if (butaca.libre && butaca.precios && butaca.precios.length > 0) {    
                        this.drawPopover(circle, null, title, butaca);
                        circle.setAttribute('fill', this.originalColor);
                
                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s'
    
                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(butaca.id);
                                }
                            }, 150);
                        });                    
                    } else if (!butaca.libre && butaca.precios && butaca.precios.length > 0) {
                        this.drawPopover(circle, 'Ocupada', title);
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.ocupadaColor);
                        circle.style.fill = 'red';
                    } else {
                        this.drawPopover(circle, 'No disponible', title);
                        circle.setAttribute('no-disponible', 'true');
                        circle.setAttribute('fill', this.noDisponibleColor);
                        circle.style.fill = 'gray';
                    }

                    if(!this.paso_activo) {
                        circle.style.pointerEvents = 'none';
                    }
                }
            });

            regiones.forEach(element => {
                const svg_id = this.getButacaId(element);
                const region = regionesFiltered.find(region => region.svg_id == svg_id);

                if (region) {
                    if (region.libres > 0 && region.precios.length > 0) {
                        const content = this.getRegionPrecio(region);
                        this.drawPopover(element, content, region.nombre);
    
                        element.addEventListener('click', () => {
                            if (!this.continuarConCompra) {
                                const popover = document.querySelector('.popover');
                                if (popover) {
                                    popover.remove();
                                }
                                this.regionSeleccionada = region;
                                this.butacas.forEach(butaca => {
                                    return butaca.seleccionada = false;
                                });
                                this.butacasSeleccionadas = [];
                                this.showModalEntradas(region.precios);                                
                            }
                        });
                    } else if (region.libres <= 0 && region.precios.length > 0) {
                        element.style.fill = 'red';
                        element.style.cursor = 'disabled';
                        this.drawPopover(element, 'Entradas agotadas', region.nombre);
                    } else {
                        element.style.fill = 'gray';
                        element.style.cursor = 'disabled';
                        this.drawPopover(element, 'No disponible', region.nombre);
                    }

                    if(!this.paso_activo) {
                        element.style.pointerEvents = 'none';
                    }
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },
        clickButaca(butaca_id) {
            let butacaSeleccionada = this.butacas.find(butacas => butacas.id == butaca_id);
            if (butacaSeleccionada && this.paso_activo) {
                butacaSeleccionada.seleccionada = butacaSeleccionada?.seleccionada && butacaSeleccionada.seleccionada ? false : true;
                butacaSeleccionada.sin_sector = true;
                if (butacaSeleccionada.seleccionada) {
                    this.butacasSeleccionadas.push(butacaSeleccionada);
                } else {
                    const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id == butacaSeleccionada.id);
                    
                    if (index !== -1) {
                        this.butacasSeleccionadas.splice(index, 1);
                    }
                }
            }
        },
        getRegionPrecio(region) {
            const lowestPrice = region.precios.reduce((lowest, current) => {
                const currentPrice = parseFloat(current.precio);
                if (!lowest || currentPrice < lowest) {
                    return currentPrice;
                }

                return lowest;
            }, null);

            return `Desde: ${lowestPrice}€`;
        },
        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(butaca) {
            const nButaca = butaca.butaca;
            const nFila = butaca.fila;
            const sector = butaca.sector_name;

            if (sector) {
                return `Sector: ${sector} - Fila: ${nFila} - Butaca: ${nButaca}`;
            }

            return `Fila: ${nFila} - Butaca: ${nButaca}`;
        },
        drawPopover(circle, content, title = null, butaca = null) {
            let contentFormatted = '';
            if (butaca) {
                const preciosContent = this.generatePriceContent(butaca.precios);
                if (preciosContent !== '') {
                    contentFormatted += '<b>Precios:</b>';
                    contentFormatted += preciosContent;
                }
            }

            const popoverOptions = {
                title: title,
                content: content ?? contentFormatted,
                trigger: 'hover',
                html: true
            }

            new Popover(circle, popoverOptions);
        },
        generatePriceContent(precios) {
            let content = '';

            content += '<ul class="pb-0 mb-0">';
            if (precios && precios.length > 0) {
                precios.forEach(precio => {
                    content += `<li>${precio.description}: ${precio.precio + ' €'}</li>`;
                });
            } else {
                content += '<li>No tiene precios configurados</li>'
            }
            content += '</ul>';

            return content;
        },
        label({
            description,
            precio,
            price_management_taquilla_interno,
            price_management_taquilla
        }) {
            var total = parseFloat(precio) + price_management_taquilla

            if (price_management_taquilla_interno == 1) {
                return (
                    description +
                    ' - (' +
                    parseFloat(precio).toFixed(2) +
                    '€' +
                    ')'
                )
            } else {
                return (
                    description +
                    ' - (' +
                    parseFloat(total).toFixed(2) +
                    '€' +
                    ')'
                )
            }
        },
        showModalEntradas(precios) {
            this.preciosSeleccionados = precios;
            this.showModalRegionSinNumerar = true;

            this.$nextTick(() => {
                this.$modal.show('modal-region-sin-numerar');
            })
        },
        closeModal() {
            this.showModalRegionSinNumerar = false;
        },
    },
    watch: {
        paso_activo(estaActivo) {
            if (!estaActivo) {
                this.renderLeafletSvg(this.svg);
            }
        }
    },
    created() {
        this.getButacas();
        this.getRegionesSinNumerar();
    },
    components: {
        LeafletComponent, ModalRegionSinNumerar
    }
}
</script>

<style>
.contentor-loading-padding {
  margin-bottom: 50px;
}
</style>